import ReactDOM from 'react-dom';

import { ThemeProvider } from '@mui/material/styles';
import { App } from './App';
import { GlobalStyle, theme } from './styles';

ReactDOM.render(
    <>
        <GlobalStyle />
        <ThemeProvider theme={theme}>
            <App />
        </ThemeProvider>
    </>,
    document.getElementById('root')
);
